import { styled } from 'styled-components';

export const Container = styled.div`
  padding: 2rem 0;
  .fullWidth {
    width: 100%;
  }
`;

export const AppointmentHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1.5rem;
  margin: 0 0 2rem;

  h1 {
    margin-bottom: 0;
  }
`;
